import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/404',
      name: '404',
      component: require('@/pages/common/404')
    },
    {
      path: '*',
      redirect: '404'
    },
    {
      path: '/',
      name: 'Index',
      component: require('@/pages/common/index'),
      meta: {
        auth: false
      }
    },
    {
      path: 'opret-swop',
      name: 'CreateSwop',
      component: require('@/pages/common/createSwop'),
      meta: {
        auth: false
      }
    },
    {
      path: '/swop/:id',
      name: 'SingleSwop',
      component: require('@/pages/common/singleSwop'),
      meta: {
        auth: false
      }
    },
    {
      path: '/historik',
      name: 'History',
      component: require('@/pages/common/history'),
      meta: {
        auth: false
      }
    },
    {
      path: '/statistik',
      name: 'Stats',
      component: require('@/pages/common/stats'),
      meta: {
        auth: false
      }
    },
    {
      path: '/indstillinger',
      name: 'Settings',
      component: require('@/pages/common/settings'),
      meta: {
        auth: false
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js